import { Point, Size } from '../../models';

export const cardFirstPositionLeft: Point = { x: 9, y: -5 };
export const cardLastPositionLeft: Point = { x: 190, y: -5 };

export const cardFirstPositionRight: Point = { x: 130, y: 105 };
export const cardLastPositionRight: Point = { x: 340, y: 105 };

// export const cardFirstPositionUnlimitedRight: Point = { x: -9, y: 57 };
// export const cardLastPositionUnlimitedRight: Point = { x: 134, y: 57 };

// export const cardFirstPositionUnlimitedLeft: Point = { x: 206, y: 57 };
// export const cardLastPositionUnlimitedLeft: Point = { x: 349, y: 57 };

// export const hiddenCardPositionsUnlimitedLeft: Point[] = [
//     { x: 72, y: 86 },
//     { x: 59, y: 97 },
//     { x: 47, y: 107 },
//     { x: 35, y: 118 },
//     { x: 24, y: 129 },
// ];

// export const hiddenCardPositionsUnlimitedRight: Point[] = [
//     { x: 273, y: 86 },
//     { x: 287, y: 97 },
//     { x: 298, y: 107 },
//     { x: 310, y: 118 },
//     { x: 319, y: 129 },
// ];

export const cardWidth = 86; // ✅
export const cardHeight = 122; // ✅
export const hiddenCardAssetSize: Size = { width: 71, height: 103 };
export const hiddenCardInnerSize: Size = { width: 45, height: 77 };
export const hiddenCardShadow = 13;

export interface HiddenCardLayout {
    x: number;
    top: number;
    rotationDeg: number;
    zIndex: number;
}

export const hiddenCardSlots: HiddenCardLayout[] = [
    { x: -12, top: 122, rotationDeg: -62, zIndex: 1 },
    { x: -6, top: 115, rotationDeg: -52, zIndex: 2 },
    { x: 0, top: 109, rotationDeg: -42, zIndex: 3 },
    { x: 5, top: 105, rotationDeg: -25, zIndex: 4 },
    { x: 11, top: 101, rotationDeg: -12, zIndex: 5 },
    { x: 17, top: 98, rotationDeg: -1, zIndex: 6 },
    { x: 24, top: 99, rotationDeg: 13, zIndex: 7 },
];

export const hiddenCardSlotIndexesByCount: { [count: number]: number[] } = {
    2: [2, 4],
    3: [2, 3, 4],
    4: [2, 3, 4, 5],
    5: [2, 3, 4, 5, 6],
    6: [1, 2, 3, 4, 5, 6],
    7: [0, 1, 2, 3, 4, 5, 6],
};

export function getHiddenCardLayouts(count: number): HiddenCardLayout[] {
    const indexes =
        hiddenCardSlotIndexesByCount[count] || hiddenCardSlotIndexesByCount[2];
    return indexes.map((index) => hiddenCardSlots[index]);
}

export const handWidthRatio = 0.45125;
export const handStepRatio = 0.45125;
export const handStepRatio7 = handStepRatio * 0.94;
export const handStepRatioSmall = 0.4275;
export const handStepRatioPair = 0.6958;
export const handMaxRowWidth = 339.102225;
export const handCardWMax = 117.936;
export const handAnchorFigma: Point = { x: 100, y: 154.0959 };
export const handAnchorYSmall = 153.95;
export const handCardAspectRatio = 1.5;
export const handPublicCardLiftRatio = 40 / (cardHeight * 2);

export function handStepRatioFor(n: number): number {
    const count = Math.max(2, n);
    if (count === 2) { return handStepRatioPair; }
    if (count <= 5) { return handStepRatioSmall; }
    if (count === 7) { return handStepRatio7; }
    return handStepRatio;
}

export function handAnchorYFor(n: number): number {
    return Math.max(2, n) <= 5 ? handAnchorYSmall : handAnchorFigma.y;
}

export function handCardWidth(n: number): number {
    const count = Math.max(2, n);
    if (count <= 5) { return handCardWMax; }
    const widthCount = Math.min(count, 6); // 6 and 7 share the same card size
    return Math.min(handCardWMax, handMaxRowWidth / (1 + (widthCount - 1) * handWidthRatio));
}

export const cardScaleStandard = 1.15;

// export const cardScaleUnlimited = 1.15;
// export const cardScaleUnlimitedHoldEm = 1.25;
// export const hiddenCardScaleUnlimited = 0.75;

export const cardScaleCharrig = 1.25;

// export const hiddenCardRotationUnlimited = -0.785; // -45 deg
